import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { FlexLayoutModule, FlexModule } from '@ngbracket/ngx-layout';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTabsModule } from 'ng-zorro-antd/tabs';

import { DialogConfirmPromptModule } from '@libs/src/dialog-confirm-prompt/dialog-confirm-prompt.module';
import { MakeSortStringFnPipeModule } from '@main-client/src/app/pipes/make-sort-string-fn/make-sort-string-fn-pipe.module';
import { ProgramParticipantsFilterModule } from '@main-client/src/app/program-participants-filter/program-participants-filter.module';

import { ActionItemDrawerComponent } from './action-item-drawer.component';

@NgModule({
  declarations: [ActionItemDrawerComponent],
  exports: [ActionItemDrawerComponent],
  imports: [
    CommonModule,
    DialogConfirmPromptModule,
    FlexLayoutModule,
    FlexModule,
    FormsModule,
    MakeSortStringFnPipeModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    NzCheckboxModule,
    NzDrawerModule,
    NzSelectModule,
    NzTableModule,
    NzTabsModule,
    ProgramParticipantsFilterModule,
    ReactiveFormsModule,
  ],
})
export class ActionItemDrawerModule {}
